import React, { useState } from "react";
import { Modal } from "antd";
import Draggable from "react-draggable";
import { Form, Spinner } from "react-bootstrap";
import { consultantServices } from "../../../APIServices/Editor/consultantServices";
const AddNewDevelopmentFileModal = ({
  show,
  title,
  bounds,
  submit,
  setShow,
  onStart,
  disabled,
  onMouseOut,
  draggleRef,
  onMouseOver,
  subFolderId,
  sub1FolderId,
  sub2FolderId,
  sub3FolderId,
  sub4FolderId,
  sub5FolderId,
  sub6FolderId,
  type,
  structuredType,
  getProjectFolderStructured,
}) => {
  let [fileName, setFileName] = useState("")
  const [loader, setLoader] = useState(false);


  const addNewDevelopmentFile = async () => {
    setLoader(true);
    let finalFolderId = type === "subFolder" ? subFolderId : type === "sub1Folder" ? sub1FolderId : type === "sub2Folder" ? sub2FolderId : type === "sub3Folder" ? sub3FolderId : type === "sub4Folder" ? sub4FolderId: type === "sub5Folder" ? sub5FolderId: type === "sub6Folder" ? sub6FolderId : "";
    let userData = {};
    userData.folderId = finalFolderId;
    userData.name = fileName;
    userData.structuredType = structuredType;
    let data = await consultantServices.addNewDevelopmentFile(userData);
    if (data?.statusCode === 200) {
      setShow(false);
      setLoader(false);
      setFileName("");
      getProjectFolderStructured(finalFolderId, type);
    }
  };

  return (
    <>
      <Modal
        title={
          <div
            className="modal_Heading"
            onMouseOver={() => {
              if (disabled) {
                onMouseOver();
              }
            }}
            onMouseOut={onMouseOut}
          >
            <h5>{title}</h5>
          </div>
        }
        width={400}
        open={show}
        onOk={() => setShow(!show)}
        onCancel={() => setShow(!show)}
        modalRender={(modal) => (
          <Draggable
            disabled={disabled}
            bounds={bounds}
            nodeRef={draggleRef}
            onStart={(event, uiData) => onStart(event, uiData)}
          >
            <div ref={draggleRef}>{modal}</div>
          </Draggable>
        )}
      >
        <div className="common_css">
          <Form.Label>
            File Name<span>*</span>
          </Form.Label>
          <Form.Control
            required
            type="text"
            value={fileName}
            onChange={(e) => setFileName(e.target.value)}
            placeholder="Enter File Name"
            autoFocus
          />
        </div>
        <hr className="w-100 m-0" />
        <div className="button_type footer_btn text-end px-3 pt-2">
          <button
            disabled={!fileName}
            onClick={addNewDevelopmentFile}
          >
            {loader ? (
                <Spinner
                  animation="border"
                  style={{ width: 13, height: 13 }}
                  className="me-1"
                />
              ) : null}
            {submit}
          </button>
        </div>
      </Modal>
    </>
  );
};
export default AddNewDevelopmentFileModal;
